function isString(maybe) {
  return typeof maybe === 'string';
}

export { isString as default };
